import { Link, useLocation } from "react-router-dom";

interface NavLink {
    key: string;
    route: string;
    label: string;
    iconClass?: string;
}

const links: NavLink[] = [
   // { key: 'tools', route: '/tools/', label: 'Home'},
    { key: 'ear-training', route: '/tools/ear-training', label: 'Ear Training'},
];

export default function ToolsNavMenu() {

    const { pathname } = useLocation();
    const currentSection = getCurrentSection(pathname);

    function getCurrentSection(currentPath: string): string {
        let currentSection = '';
        var navLink = links.find(l => l.route.startsWith(currentPath));

        if (navLink) {
            currentSection = navLink.key;
        }

        return currentSection;
    }

    function isCurrentSection(section: string): boolean {
        return currentSection === section;
    }

    return (
        <div className="menu">
            <ul className="nav nav-pills flex-column mb-auto">
                {links.map(link =>
                    <li key={link.key} className={`nav-item }`}>
                        <Link to={link.route} className={`nav-link text-white ${isCurrentSection(link.key) ? 'active' : ''}`}>{link.label}</Link>
                    </li>
                )}
            </ul>
        </div>
    );
}